import React from 'react';

import { ComponentInfo } from '@components';

import { Logo, DoubtsAndExit, WizardMenu, IntroWizard } from './block';
import { useLateralMenuHelper } from './lateralMenu.helper';

export const LateralMenuPlaceholder: React.FC = () => {
	const { isIntroRoute } = useLateralMenuHelper();

	return (
		<ComponentInfo name="LateralMenuPlaceholder" type="placeholder">
			<Logo />
			{isIntroRoute ? <IntroWizard /> : <WizardMenu />}
			<DoubtsAndExit />
		</ComponentInfo>
	);
};
